import { TenantEntity } from '../TenantEntity'
import { DataSyncBase } from '@/class/model/DataSyncBase'

export class QuotationPrePortLastMileDetail extends DataSyncBase {
  /**
   * Constructor
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'QuotationPrePortLastMileDetail'
  }

  get quotationUuid() {
    return this._data.quotationUuid
  }
  set quotationUuid(quotationUuid) {
    this._data.quotationUuid = quotationUuid || ''
  }

  get priceUuid() {
    return this._data.priceUuid
  }
  set priceUuid(priceUuid) {
    this._data.priceUuid = priceUuid || ''
  }

  get priceNo() {
    return this._data.priceNo
  }
  set priceNo(priceNo) {
    this._data.priceNo = priceNo || ''
  }

  get priceMethod() {
    return this._data.priceMethod
  }
  set priceMethod(priceMethod) {
    this._data.priceMethod = priceMethod || 1 // Default is 1 (Direct drag)
  }

  get branchLine() {
    return this._data.branchLine
  }
  set branchLine(branchLine) {
    this._data.branchLine = branchLine || 0 // Default is 0 (No branch line)
  }

  get wharf() {
    return this._data.wharf
  }
  set wharf(wharf) {
    this._data.wharf = wharf || ''
  }

  get supplier() {
    return this._data.supplier
  }
  set supplier(supplier) {
    this._data.supplier = supplier || 0 // Default is 0
  }

  get beginDate() {
    return this._data.beginDate
  }
  set beginDate(beginDate) {
    this._data.beginDate = beginDate
  }

  get endDate() {
    return this._data.endDate
  }
  set endDate(endDate) {
    this._data.endDate = endDate
  }

  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks || ''
  }

  get type() {
    return this._data.type
  }
  set type(type) {
    this._data.type = type || 0 // Default is 0 (Port before pricing)
  }

  get deliveryAddressType() {
    return this._data.deliveryAddressType
  }
  set deliveryAddressType(deliveryAddressType) {
    this._data.deliveryAddressType = deliveryAddressType || 1 // Default is 1 (Third-party address)
  }

  get postalCode() {
    return this._data.postalCode
  }
  set postalCode(postalCode) {
    this._data.postalCode = postalCode || ''
  }

  get address() {
    return this._data.address
  }
  set address(address) {
    this._data.address = address || ''
  }

  get warehouseCode() {
    return this._data.warehouseCode
  }
  set warehouseCode(warehouseCode) {
    this._data.warehouseCode = warehouseCode || ''
  }

  get agentName() {
    return this._data.agentName
  }
  set agentName(agentName) {
    this._data.agentName = agentName || 0
  }

  get pol() {
    return this._data.pol
  }
  set pol(pol) {
    this._data.pol = pol || ''
  }

  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod || ''
  }

  get byEqSizeChargingItems() {
    return this._data.byEqSizeChargingItems
  }
  set byEqSizeChargingItems(byEqSizeChargingItems) {
    this._data.byEqSizeChargingItems = byEqSizeChargingItems || []
  }

  get notByEqSizeChargingItems() {
    return this._data.notByEqSizeChargingItems
  }
  set notByEqSizeChargingItems(notByEqSizeChargingItems) {
    this._data.notByEqSizeChargingItems = notByEqSizeChargingItems || []
  }
}
